export default "__VITE_ASSET__BHDmNPrH__"